<template>
  <div>
    <v-card
      class="mt-1 mb-1 px-3 py-2 d-flex justify-center"
      color="#EFEFEF"
      v-if="documentsToSend.length === 0"
    >
      Aucun document à envoyer
    </v-card>
    <div v-for="folder in reqFolders" :key="folder._id">
      <h2 class="mt-4">{{ folder.title }}</h2>
      <DocumentChip
        v-for="d in documentsToSend"
        :key="d._id"
        v-if="d.parentFolder === folder._id"
        :document="d"
        @change="showMessageAndReload()"
      />
      <v-snackbar v-model="showSuccess" :top="true" :timeout="7000"
        >Document transmis !</v-snackbar
      >
    </div>
  </div>
</template>

<script>
import DocumentChip from "../commons/DocumentChip";

export default {
  name: "DocumentsToSend",
  components: { DocumentChip },
  props: ["folders", "documents"],
  data() {
    return { showSuccess: false };
  },
  computed: {
    documentsToSend() {
      return this.documents;
    },

    reqFolders() {
      const order = ["Dossier Mobilipass", "Dossier Locatif", "Dossier Garant"];
      const orderIndex = str => {
        for (let i = 0; i < order.length; i++) {
          const o = order[i];
          if (str.indexOf(o) >= 0) {
            return i;
          }
        }
        return Infinity;
      };
      return this.folders
        .filter(
          f =>
            this.documentsToSend.filter(
              ({ parentFolder }) => parentFolder === f._id
            ).length > 0
        )
        .sort((a, b) => {
          const aIdx = orderIndex(a.title);
          const bIdx = orderIndex(b.title);
          if (aIdx > bIdx) {
            return 1;
          }
          if (aIdx < bIdx) {
            return -1;
          }
          return 0;
        });
    }
  },
  methods: {
    showMessageAndReload() {
      this.showSuccess = true;
      this.$emit("upload");
    }
  }
};
</script>

<style scoped></style>
